import "./App.css";
import Primary from "./components/buttons/primary/Primary";
import Secondary from "./components/buttons/secondary/Secondary";
import Contact from "./components/Contact/Contact";
import ContactDrawer from "./components/ContactDrawer/ContactDrawer";
import Footer from "./components/Footer/Footer";
import Hero from "./components/Hero/Hero";
import Layout from "./components/Layout/Layout";
import MenuDrawer from "./components/MenuDrawer/MenuDrawer";
import Metadata from "./components/Metadata/Metadata";
import NavBar from "./components/NavBar/NavBar";
import Projects from "./components/Projects/Projects";

function App() {
  return (
    <div className="App">
      <Metadata />
      <NavBar />
      <ContactDrawer />
      <MenuDrawer />
      <Layout>
        <Hero />
        <Projects />
        <Contact />
      </Layout>
      <Footer />
    </div>
  );
}

export default App;
